import type { Quantity } from 'fhir/r4';

export const quantityLabel = (quantity?: Quantity): string =>
  quantity?.value ? `${quantity.value} ${quantity.unit}` : '';
